import React from 'react';

import { GridColDef, GridRowParams, GridValueFormatterParams } from '@mui/x-data-grid';

import CustomDataGrid from '../../components/data-grid';
import GlobalStyles from '../../global-styles';
import { formatDateForDataGrid } from '../../utils/helper';
import { Box } from '../../utils/material-ui-core';

interface ListProps {
  kitItems: KitItem[];
  onCallback: (kitItem: KitItem) => void;
}

const KitItemList = ({ kitItems, onCallback }: ListProps) => {
  const globalStyles = GlobalStyles();

  const columns: GridColDef[] = [
    { field: "name", headerName: "Name", width: 250 },
    { field: "quantity", headerName: "Quantity", width: 150, type: "number" },
    { field: "partNumber", headerName: "SKU", width: 200 },
    {
      field: "rollupItem",
      headerName: "Rollup Item",
      width: 170,
      type: "boolean",
    },
    {
      field: "rechargeProductStatusDescription",
      headerName: "Recharge Status",
      width: 200,
    },
    { field: "title", headerName: "Title", width: 200, hide: true },
    {
      field: "intervalFrequency",
      headerName: "Frequency",
      width: 130,
      type: "number",
      hide: true,
    },
    { field: "intervalUnit", headerName: "Unit", width: 130, hide: true },
    {
      field: "price",
      headerName: "Price",
      width: 130,
      type: "number",
      hide: true,
    },
    {
      field: "shopifyVariantId",
      headerName: "Variant",
      width: 200,
      hide: true,
    },
    {
      field: "subscriptionId",
      headerName: "Subscription",
      width: 200,
      hide: true,
    },
    {
      field: "taxable",
      headerName: "Taxable",
      width: 130,
      type: "boolean",
      hide: true,
    },
    { field: "deviceOwnership", headerName: "Ownership", width: 200 },
    { field: "platformVendorName", headerName: "Platform Vendor", width: 200 },
    {
      field: "lastModifiedBy",
      headerName: "Last Modified By",
      width: 250,
      hide: true,
    },
    {
      field: "lastModifiedDateTime",
      headerName: "Last Modified Date",
      width: 200,
      type: "dateTime",
      valueFormatter: (params: GridValueFormatterParams) => formatDateForDataGrid(params.value as string),
    },
    {
      field: "kitItemKey",
      headerName: "Key",
      width: 400,
      filterable: false,
      hide: true,
    },
  ];

  const handleDataGridClick = (params: GridRowParams, event: any) => {
    onCallback(kitItems[params.row.id]);
  };

  const getData = () => {
    const rows: any = [];
    kitItems.map((kitItem, index) => rows.push({ id: index, ...kitItem }));
    return rows;
  };

  return (
    <Box className={globalStyles.onboardingDatagridContainer}>
      <CustomDataGrid uniqueGridCode={"KitItemListResult"} columns={columns} rows={getData()} showToolBar={true} sortModel={[{ field: "name", sort: "asc" }]} handleDataGridClick={handleDataGridClick} />
    </Box>
  );
};

export default KitItemList;
